<<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">

      <el-form-item label="名称" required>
        <el-input v-model="form.name" size="small" style="width:80%"></el-input>
      </el-form-item>

      <el-form-item label="API名称" required>
        <el-input v-model="form.apiName" size="small" style="width:80%"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.description" size="small" style="width:80%"></el-input>
      </el-form-item>
      <el-form-item label="类型" required>
        <!-- <el-input v-model="form.type" size="small" style="width:80%"></el-input> -->
        <el-select v-model="form.type" :placeholder="$t('message.placeholder.search')" style="width:80%">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" required>
        <el-input v-model="form.address" size="small" style="width:80%"></el-input>
      </el-form-item>
      <el-form-item label="启动位置" required>
        <!-- <el-input v-model="form.startupPosition" size="small" style="width:80%"></el-input> -->
        <el-select v-model="form.startupPosition" :placeholder="$t('message.placeholder.search')" style="width:80%">
          <el-option v-for="item in positionList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('message.table.isEnabled')">
        <el-switch v-model="form.enabled" />
      </el-form-item>


      <el-form-item>
        <el-button type="primary" size="mini" @click="onSubmit"> {{ $t("message.button.save") }}</el-button>
        <el-button size="mini"> {{ $t("message.button.cancel") }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

  <script>
  export default {
    data() {
      return {
        form: {},
        typeOptions: [
          { value: 'url', label: 'url' },
          { value: 'handle', label: 'handle' }
        ],
        positionList: [
          { label: '下拉菜单', value: 'drop' }
        ]
      }
    },
    props: ['data'],
    methods: {
      onSubmit() {
        const { enabled, ...obj } = this.form;
        const actived = Number(enabled);
        this.$emit('sendData', { ...obj, actived });

      },
      setData() {
        if (!this.data) {
          return
        }
        this.form = { ...this.data }
      }
    },

    watch: {
      data() {
        this.setData()
      }

    },
    created() {
      this.setData()
    },

  }
</script>

  <style scoped></style>